module.exports = __webpack_public_path__ + "static/media/Demo1.ca8d6c61.svg";